// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectSourceMappingMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_SOURCE_LIST);
        this.RouteId = 0;
        this.SourceIDs = [];
        this.SourceNames = [];
        this.SourceExternalIds = [];
    }
}
